import { useEffect, useState } from "react";
import { UseQueryResult } from "react-query";
import { useNavigate } from "react-router-dom";

import { getDossier } from "../api/dossier/getDossier";
import { PageDirectoryEntryName } from "../api/PageDirectory";
import { canAccessVehicleSourcingFlow } from "../helpers/dossiers";
import { useAuth } from "../providers/AuthProvider";
import { Dossier } from "../types/Dossier";

type UseVehicleSourcingAccessParams = {
  dossierId: string;
  redirectTo?: PageDirectoryEntryName;
};

type UseVehicleSourcingAccessReturn = {
  dossier: UseQueryResult<Dossier>;
  navigationCheckComplete: boolean;
  isLoading: boolean;
  isSuccess: boolean;
};

export const useVehicleSourcingAccess = ({
  dossierId,
}: UseVehicleSourcingAccessParams): UseVehicleSourcingAccessReturn => {
  const navigate = useNavigate();
  const { getScopedPageUrl } = useAuth();
  const [navigationCheckComplete, setNavigationCheckComplete] = useState(false);

  const dossier = getDossier(dossierId);

  if (dossier.isError) {
    throw dossier.error;
  }

  useEffect(() => {
    if (dossier.isSuccess) {
      if (!canAccessVehicleSourcingFlow(dossier.data)) {
        navigate(getScopedPageUrl("viewDossier", dossierId), { replace: true });
      } else {
        setNavigationCheckComplete(true);
      }
    }
  }, [dossier.isSuccess, dossier.data, dossierId]);

  return {
    dossier,
    navigationCheckComplete,
    isLoading: dossier.isLoading,
    isSuccess: dossier.isSuccess,
  };
};
